import {
	faAmazon,
	faFacebookSquare,
	faLine,
	faXTwitter
} from '@fortawesome/free-brands-svg-icons';
import {
	faChevronLeft,
	faChevronRight,
	faSquare
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Slider from 'react-slick';
import { ItemDetail } from '../interfaces';
import {
	Anime,
	Classic,
	Hero,
	Other,
	Toei,
	useWindowDimensions
} from '../shared';
import { Layout } from './layout';
import { SEO } from './seo';

export const ProductDetailBase = ({ ctx }) => {
	const data = ctx.data as ItemDetail;
	const nexts = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					siteUrl
				}
			}
			details {
				list {
					id
					productName
					genre
					image {
						url
					}
					previous {
						id
					}
				}
			}
			genre {
				list {
					name
					saler
				}
			}
		}
	`);
	const siteUrl = nexts.site.siteMetadata.siteUrl;
	const [state, setState] = useState({
		showRelated: false,
		related: [] as ItemDetail[]
	});
	const isMobile = useMediaQuery({ query: '(max-width: 575.98px)' });
	const isTab = useMediaQuery({ query: '(max-width: 1120px)' });
	const { width } = useWindowDimensions();
	const list = nexts.details.list as ItemDetail[];
	const genre = nexts.genre.list as { name: string; saler: string }[];
	const next = list.find(x => x.previous?.id === data?.id);
	useEffect(() => {
		setTimeout(() => {
			const related = list
				.filter(x => x.id !== data?.id)
				.filter(x => data?.genre[0] === x.genre[0])
				.reduce((a, b, i, arr) => {
					const j = Math.floor(Math.random() * (i + 1));
					[arr[i], arr[j]] = [arr[j], arr[i]];
					return arr;
				}, new Array<ItemDetail>());
			setState({ showRelated: true, related });
		}, 50);
	}, []);
	const genres = [Hero, Anime, Classic, Toei, Other];
	const select = (genre: string[]) => {
		if (!genre) {
			return undefined;
		}
		return genres.find(x => genre[0]?.includes(x.genre));
	};
	return (
		<Layout>
			<SEO
				title={data?.productName}
				imageUrl={data?.ogpImage?.url || data?.image.url}
			/>
			<div className="bread">
				<ul>
					<li>
						<Link to="/">HOME</Link>
					</li>
					<li>
						<Link to="/product-list">DVD&Blu-ray</Link>
					</li>
					<li>{data?.productName}</li>
				</ul>
			</div>
			<article className="detail-article">
				<div className="itemSummary">
					<div className="itemSummary__jaket">
						<Slider
							{...{
								dots: true,
								arrows: false
							}}
						>
							<picture>
								<source
									srcSet={`${data?.image.url}?w=500&fm=webp`}
									type="image/webp"
								/>
								<img
									src={`${data?.image.url}?w=500`}
									alt="jaket"
								/>
							</picture>
							{data?.image2?.url && (
								<picture>
									<source
										srcSet={`${data?.image2.url}?w=500&fm=webp`}
										type="image/webp"
									/>
									<img
										src={`${data?.image2.url}?w=500`}
										alt="jaket"
									/>
								</picture>
							)}
							{data?.image3?.url && (
								<picture>
									<source
										srcSet={`${data?.image3.url}?w=500&fm=webp`}
										type="image/webp"
									/>
									<img
										src={`${data?.image3.url}?w=500`}
										alt="jaket"
									/>
								</picture>
							)}
						</Slider>
					</div>
					<ul className="summarylist">
						<li id="item--genre">
							<span
								className={`badge ${select(data?.genre)?.code}`}
							>
								{select(data?.genre)?.label}
							</span>
						</li>
						<li id="item--title">
							<h2>{data?.productName}</h2>
						</li>
						<li id="item--sns" className="sns-link">
							<a
								target="_blank"
								rel="nofollow noreferrer"
								href={`https://twitter.com/share?text=${encodeURIComponent(
									data?.productName
								)}&url=${encodeURIComponent(
									`${siteUrl}/${data?.id}`
								)}`}
							>
								<FontAwesomeIcon icon={faXTwitter} size="1x" />
							</a>
							<a
								target="_blank"
								rel="nofollow noreferrer"
								href={`https://www.facebook.com/share.php?u=${encodeURIComponent(
									`${siteUrl}/${data?.id}`
								)}`}
							>
								<FontAwesomeIcon
									icon={faFacebookSquare}
									size="1x"
								/>
							</a>
							<a
								target="_blank"
								rel="nofollow noreferrer"
								href={`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
									`${siteUrl}/${data?.id}`
								)}`}
							>
								<FontAwesomeIcon icon={faLine} size="1x" />
							</a>
						</li>
						<li id="item__d-type">{data?.type}</li>
						{!!data?.productNumber && (
							<li id="item__productnumber">
								{data?.productNumber}
							</li>
						)}
						<li id="item__a-btn">
							<a
								href={data?.amazonLink}
								className={`btn btn-abtn ${
									!data?.amazonLink ? 'disabled' : ''
								}`}
								target="_blank"
							>
								{!!data?.amazonLink && (
									<>
										<FontAwesomeIcon
											icon={faAmazon}
											size="1x"
										/>
										<span className="ml-1">amazon</span>
									</>
								)}
								{!data?.amazonLink && (
									<span className="ml-1">販売終了</span>
								)}
							</a>
						</li>
					</ul>
				</div>
				<div className="d-flex pb-3 px-3">
					{!!data?.previous?.id && (
						<Link
							to={`/${data?.previous.id}`}
							className="item-prev"
						>
							<span className="fa-layers fa-2x">
								<FontAwesomeIcon icon={faSquare} size="1x" />
								<FontAwesomeIcon
									icon={faChevronLeft}
									color="white"
									transform={'shrink-6'}
									size="1x"
								/>
							</span>
							<span className="text">前の巻へ</span>
						</Link>
					)}
					{!!next && (
						<Link to={`/${next.id}`} className="item-next">
							<span className="text">次の巻へ</span>
							<span className="fa-layers fa-2x">
								<FontAwesomeIcon icon={faSquare} />
								<FontAwesomeIcon
									icon={faChevronRight}
									color="white"
									transform={'shrink-6'}
									size="1x"
								/>
							</span>
						</Link>
					)}
				</div>
				<section className="row border-top">
					<h5 className="px-5 py-3">
						<div className="badge-detail">商品仕様</div>
					</h5>
					<p
						className="border-left m-0 px-5 py-3"
						style={{ whiteSpace: 'pre-line' }}
					>
						{data?.spec}
					</p>
				</section>
				<section className="row border-top">
					<h5 className="px-5 py-3">
						<div className="badge-detail">作品内容</div>
					</h5>
					<p
						className="border-left m-0 px-5 py-3"
						style={{ whiteSpace: 'pre-line' }}
					>
						<div className="catch">
							{data?.catchPhrase && (
								<div
									dangerouslySetInnerHTML={{
										__html: data?.catchPhrase
									}}
								></div>
							)}
						</div>
						<div className="point">
							{data?.salesPoint && (
								<div
									dangerouslySetInnerHTML={{
										__html: data?.salesPoint
									}}
								></div>
							)}
						</div>
						<div>{data?.content}</div>
					</p>
				</section>
				<section className="row border-top">
					<h5 className="px-5 py-3">
						<div className="badge-detail">スタッフ・キャスト</div>
					</h5>
					<p
						className="border-left m-0 px-5 py-3"
						style={{ whiteSpace: 'pre-line' }}
					>
						{data?.detail}
					</p>
				</section>
				<section className="row border-top  border-bottom">
					<h5 className="px-5 py-3">
						<div className="badge-detail">発売元・販売元</div>
					</h5>
					<p
						className="border-left m-0 px-5 py-3"
						style={{ whiteSpace: 'pre-line' }}
					>
						{genre.find(x => x.name === data?.genre[0])?.saler}
					</p>
				</section>
				<div className="sectionArea">
					<section className="relatedItem">
						<h1 className="section-title">RELATED ITEM</h1>
						<ul id="relatedList">
							{state.showRelated &&
								state.related
									.slice(
										0,
										isMobile
											? 2
											: isTab
												? Math.floor(width / 100) - 4
												: Math.floor(width / 100) - 7
									)
									.map(x => (
										<li
											key={x.id}
											style={{
												width: `${
													100 /
													(isTab
														? Math.floor(
																width / 100
															) - 4
														: Math.floor(
																width / 100
															) - 7)
												}%`
											}}
										>
											<Link to={`/${x.id}`}>
												<div className="re__j-img">
													<picture>
														<source
															srcSet={`${x.image.url}?w=200&fm=webp`}
															type="image/webp"
														/>
														<img
															src={`${x.image.url}?w=200`}
															alt="jacket"
														/>
													</picture>
												</div>
												<p className="re__title">
													{x.productName}
												</p>
											</Link>
										</li>
									))}
						</ul>
					</section>
				</div>
			</article>
		</Layout>
	);
};
